import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-envelope-open',
  templateUrl: './icon-envelope-open.component.html',
  styleUrls: ['./icon-envelope-open.component.scss'],
})
export class IconEnvelopeOpenComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
